import { client } from '../client';

export const triggerMobileHandoff = async (): Promise<any> => {
  const { data } = await client.post<any>(`/mobile_handoff/create_mobile_handoff_notification`);

  return data;
};
